import React from 'react'
import { Link } from 'react-router-dom';

const SuccessMessage = ({isOpen, message, onClose}) => {

    if (!isOpen) return null;
      return (
        <div className="fixed rounded-md w-full inset-0 flex items-center justify-center z-50">
            <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>
            <div className="bg-white w-1/2 p-6 rounded shadow-lg z-10 px-16 py-10">
                <div className='flex items-center gap-5 border-b-2 my-2 pb-3 border-gray-100'>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="green" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                </svg>
                    <h2 className="text-2xl font-bold">Success</h2>
                </div>
               
                <p className='text-sm my-2'>{message}</p>
                <div className='flex gap-5 w-full justify-center text-md font-semibold'>
                  
                    <button onClick={onClose} className="mt-4 w-1/2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600">
                        Continue
                    </button>
                </div>
                
            </div>
        </div>
  )
}

export default SuccessMessage;